export const QUERY_STATUS = {
  IDLE: 'idle',
  EMPTY: 'empty',
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
}

export const HTTP_ERROR_STATUS_CODE = 400
